import { render, staticRenderFns } from "./joinmeeting.vue?vue&type=template&id=0d21bbda&scoped=true&"
import script from "./joinmeeting.vue?vue&type=script&lang=js&"
export * from "./joinmeeting.vue?vue&type=script&lang=js&"
import style0 from "./joinmeeting.vue?vue&type=style&index=0&id=0d21bbda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21bbda",
  null
  
)

export default component.exports